import { clientId } from "../init";

const endpoints = {
  ws: window.ini.WEBSOCKET_URL,
  ws_path: window.ini.WEBSOCKET_PATH,
  // Lazy: clientId is (re)computed by bootstrapConfig() after the tenant
  // configs are fetched, which happens after this object is built.
  get configApiUrl() {
    return `${window.ini.CONFIG_API_URL}/config-api/landing-pages/list?tenantId=${clientId}`;
  },
  tenantsConfigsApiUrl: `${window.ini.CONFIG_API_URL}/config-api/landing-pages/configs`,
};

export default endpoints;